// extracted by css-extract-rspack-plugin
var _1 = "cXpU1MzCXAgseeQo";
var _2 = "pZAOgrBJwd4ehjkG";
export { _1 as "btn", _2 as "wrapper" }
